function scheduleAvailabilitySortCompare(reverse) {
  return function (a, b) {
    const t1 = a.startAt;
    const t2 = b.startAt;

    if (a.allDay !== b.allDay) {
      if (a.allDay) {
        return reverse ? 1 : -1;
      } else if (b.allDay) {
        return reverse ? -1 : 1;
      }
    }

    if (t1 !== t2) {
      return new Date(t1) < new Date(t2) ? -1 : 1;
    }

    return parseInt(a.id, 10) < parseInt(b.id, 10) ? -1 : 1;
  };
}

export default scheduleAvailabilitySortCompare;
